export const engagementEmailMessageDndEditorAccessToken = "/engagement/email-message/dnd-editor/access-token";
